import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import sleep from "sleep-promise";
import { useKeysStore } from "../../../../core/store/useKeysStore";

function Form() {
    const profileFilter = chooseProfileFilter()
    const { keys } = useKeysStore();
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const [form, setForm] = useState();
    const { id } = useParams();

    const path = '/contractualizations/';
    const paths = {
        endpointSave: config.endpoints.backend + 'contractualizations/save',
        endpointGetById: config.endpoints.backend + 'contractualizations/getById',
        endpointGetAllProjects: config.endpoints.backend + 'projects/getall',
        endpointGetAllAdjustTypes: config.endpoints.backend + 'adjusttypes/getall',
        endpointGetAllProjectUnits: config.endpoints.backend + 'projectunits/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Contratualização",
        labelTitleEdit: "Editar Contratualização",
        labelTitleView: 'Visualizar Contratualização'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'pdc_project_id',
                    type: 'select',
                    label: 'Projeto',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllProjects,
                        label: 'project_and_entity',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element,field,values) => {
                        let form = getForm(values);
                        values.pdc_units = [];
                        setForm(form);  
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                        <CustomFormContainer 
                            form = {form}
                            content = {<CustomForm form={form}/>}
                        />)
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_adjust_type_id',
                    type: 'select',
                    label: 'Tipo de Ajuste',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllAdjustTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'number',
                    type: 'text',
                    label: 'Número',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'object',
                    type: 'textarea',
                    label: 'Objeto',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'publish_date',
                    type: 'date',
                    label: 'Data de Publicação',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'file',
                    type: 'fileS3',
                    extensionAccept: '.jpeg,.jpg,.png,.ico,.pdf,.xlsx,.docx',
                    limitFileSize: keys?.limitFileSizeDefault,
                    label: 'Arquivo',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'units',
                    type: 'multiinput',
                    label: 'Unidades',
                    sortBy: 'index',
                    form: [
                        {
                            label: 'Unidade',
                            type: 'select',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllProjectUnits,
                                label: 'no_fantasia',
                                value: 'id',
                                params: {
                                    filter: {
                                        pdc_project_id: values.pdc_project_id || 'not-list'
                                    }
                                }
                            },
                            name: 'unit',
                            validations: {
                                required: true
                            }
                        }
                    ],
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
